import { render, staticRenderFns } from "./BindsMenu.vue?vue&type=template&id=69588fcc&"
import script from "./BindsMenu.vue?vue&type=script&lang=js&"
export * from "./BindsMenu.vue?vue&type=script&lang=js&"
import style0 from "./BindsMenu.vue?vue&type=style&index=0&id=69588fcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports